module.exports = __webpack_public_path__ + "img/icon_tools_user_vip.c2d13e3a.svg";